import { makeStyles } from '@material-ui/core/styles';

export const useContactStyles = makeStyles(() => ({
  title: {
    fontSize: 26,
    fontWeight: 600,
    textAlign: 'center',
    marginBottom: 30,
  },
}));
